import { render, staticRenderFns } from "./MyBalance.vue?vue&type=template&id=a071e71c&"
import script from "./MyBalance.vue?vue&type=script&lang=js&"
export * from "./MyBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports